import React, { useEffect, useState, useRef } from "react";
import {
  HeaderContainer,
  HeaderLogo,
  Menu,
  MenuIcon,
  MenuItem,
  HeaderMainWrapper,
  StyledWalletButton
} from "./style";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

import {
  ConnectWallet,
  LogoVyga,
  DarkLogoVyga,
  ArrowForwardWhite,
  LogoutIcon,
} from "../../shared/icons";
import SearchBar from "../shared-components/SearchBar";
import ConnectButton from "../shared-components/ConnectButton";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { searchNFTsAndCollections } from "../../slices/home/homeThunks";
import styled from "styled-components";
import MenuComponent from "../shared-components/MenuComponent";
import { useSelector } from "react-redux";
import { IconButton } from "../Buttons";
import { clearUserData } from "../../slices/auth/authSlice";
import LoaderToast from "../LoaderToast.tsx";
import WalletsModal from "../New/WalletsModal";
import { cookieStorage, useDisconnect } from 'wagmi';
import { QueryClient } from '@tanstack/react-query';

const ConnectBtn = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  background-color: #ff9d59;
  padding: 12px 20px;
  color: #fff;
  border-radius: 50px;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  span {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:hover {
    background-color: #e0772d;
  }
`;

const Button = styled.button`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  outline: none;
  background-color: #ff9d59;
  padding: 12px 20px;
  color: #fff;
  border-radius: 50px;
  gap: 10px;
  font-size: 16px;
  font-weight: 600;
  &:hover {
    background-color: #e0772d;
  }
`;

interface I_HeaderProps {
  contactShow?: () => void;
}

export const Header = React.memo((props: I_HeaderProps) => {
  const { contactShow } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = React.useState<boolean>(false);
  const dispatch: AppDispatch = useDispatch();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isMobile = window.innerWidth <= 1024;
  const [scrolled, setScrolled] = useState(false);
  const menuItems = [
    // { id: 1, label: "Home", path: "/" },
    { id: 2, label: "About Us", path: "/" },
    { id: 3, label: "Roadmap", path: "/roadmap" },
    // { id: 3, label: "Portfolio", path: "/portfolio" },
    // { id: 4, label: "Spotlights", path: "/spotlights" },
    { id: 5, label: "AI Asset Search", path: "/marketplace" },
    ...(isMobile ? [{ id: 6, label: "AI Ranking", path: "/marketplace" }] : []),
  ];
  const token = useSelector((state: RootState) => state?.auth?.token);
  const walletAddress = useSelector(
    (state: RootState) => state?.auth?.user?.walletAddress
  );

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50); // Change color when scrolled 50px or more
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const [searchResults, setSearchResults] = useState<any>([]);

  const [isMenuVisible, setIsMenuVisible] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const { disconnect } = useDisconnect();
  const queryClient = new QueryClient();

  const [toastOpen, setToastOpen] = useState(false);
  const handleMenuSelect = (item: string) => {
   
    if (item === "Logout") {
      cookieStorage.removeItem('wagmi.store');
      localStorage.removeItem('wagmi.wallet');
      localStorage.removeItem('walletAuthType');
      sessionStorage.removeItem('walletConnect');
      queryClient.clear();
      disconnect();
      dispatch(clearUserData());
      navigate("/");
    }
    setIsMenuVisible(false);
  };
  
  const toggleWalletMenu = () => {
    setIsMenuVisible((prev) => !prev);
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
      setIsMenuVisible(false);
    }
  };

  const isBaseUrl =
    location.pathname === "/" ||
    location.pathname === "/marketplace" ||
    menuOpen;

  React.useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleSearch = (query: string) => {
    setIsLoading(true);
    if (query.length > 0) {
      dispatch(searchNFTsAndCollections({ keyword: query, limit: 5 }))
        .then((res: any) => {
          console.log("results 1", res);
          if (res?.error) {
            throw new Error("Something went wrong");
          }
          const combinedData = res?.payload?.data?.data?.combinedData?.map(
            (item: any) => ({
              id: item?._id,
              chain: item?.chain,
              name: item?.name,
              imageUrl: item?.featureImage || item?.fileUrl,
              score: item?.score || 0,
              price: parseFloat(item?.floorPrice || 0).toFixed(4),
              networkId: item?.networkId || 1,
              type: item?.assetType,
            })
          );
          setSearchResults(combinedData);
        })
        .catch((err) => {
          setSearchResults([]);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const isScrolled = !isBaseUrl || scrolled;
  const isMenuOpen =
    menuOpen || (location.pathname === "/marketplace" && !scrolled);
  
  const logo = isMenuOpen
    ? LogoVyga
    : DarkLogoVyga;

  const manageMenu = () =>{
    setMenuOpen((prev) => !prev);
    setWalletModalOpen((prev) => !prev);
  }

  const logoutMenu = () => {
    setIsMenuVisible(true)
  }

  const renderConnectButtonMenu = () => (
    <div style={{ position: "relative" }} ref={menuRef}>
      {token ?
        <><StyledWalletButton
        onClick={
          logoutMenu
        }
      >
        My Wallet
      </StyledWalletButton>
      <MenuComponent
        items={[{ title: "Logout", icon: <LogoutIcon /> }]}
        onSelect={handleMenuSelect}
        isVisible={isMenuVisible}
      />
      </>
       :
       <ConnectButton onClick={manageMenu} />
      }
    </div>
  );

  const handleNavigateToDashboard = () => {
    setMenuOpen(false);
    navigate(`/dashboard/${walletAddress}`);
  };

  const [walletModalOpen, setWalletModalOpen] = useState<boolean>(false);

  const handleToggleModal = () => {
    setWalletModalOpen((prev) => !prev);
  };

  return (
    <>
      <LoaderToast
        open={toastOpen}
        message={"Connecting your wallet...."}
        loading={true}
        onClose={() => setToastOpen(false)}
      />
      <HeaderMainWrapper scrolled={isScrolled}>
        <HeaderContainer
          isScrolling={scrolled}
          scrolled={menuOpen || location.pathname === "/marketplace"}
          backColor={!menuOpen && location.pathname === "/"}
        >
          <div className="header_logo">
            <HeaderLogo
              src={logo}
              alt="vygalogo"
              onClick={() => navigate("/")}
            />
          </div>
          <div className="menu_right_bar">
            <MenuIcon
              scrolled={isScrolled || location.pathname == "/"}
              className={menuOpen ? "active" : ""}
              onClick={toggleMenu}
              baseUrl={location.pathname}
            >
              <span></span>
              <span></span>
            </MenuIcon>
            <Menu open={menuOpen}>
              <div className="two_side_menu">
                <div className="Open_menu_bar">
                  {menuItems.map((item, index) => {
                    return (
                      <MenuItem
                        key={item.id}
                        className={
                          location.pathname === item.path ? "active" : ""
                        }
                        onClick={() => {
                          if (location.pathname === item.path) {
                            setMenuOpen(false);
                          }
                        }}
                      >
                        <NavLink to={item.path} key={item.id}>
                          {item.label}
                        </NavLink>
                      </MenuItem>
                    );
                  })}
                  <p>
                    Discover how VYGA leverages AI to elevate growth initiatives
                    across multiple dimensions.
                  </p>
                  {/* {isMobile && renderConnectButtonMenu()} */}
                  <IconButton onClick={()=> navigate(`/termsconditions`)} icon={<ArrowForwardWhite />}>
                    Terms & Conditions{" "}
                  </IconButton>
                  <IconButton onClick={()=> navigate(`/privacypolicy`)} icon={<ArrowForwardWhite />}>
                    Privacy Policy
                  </IconButton>
                </div>
                {/*}
                {!isMobile && (
                  
                  <MenuItem className="contact_menu" onClick={contactShow}>
                    <a href="mailto:contact@vyga.co">{`Contact Now`}</a>
                  </MenuItem>
                )}
                  */}
              </div>
              <div className="bottom_header">
                <ul>
                  <li>VYGA — ©2025 All rights reserved</li>
                  <li>
                    Check our Social Media — {isMobile ? <br/> : <span></span>}
                    <a target="_blank" rel="noopener noreferrer" href="https://www.twitter.com/">X</a>
                    <span>{"|"}</span>
                    <a target="_blank" rel="noopener noreferrer" href="https://web.telegram.org/">Telegram</a>
                    <span>{"|"}</span>
                    <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/">Linkedin</a>
                  </li>
                </ul>
              </div>
            </Menu>
            {!isMobile && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "30px",
                }}
              >
                <SearchBar
                  placeholder="Digital Assets"
                  isHeaderSearch
                  handleSearch={handleSearch}
                  isLoading={isLoading}
                  searchResults={searchResults}
                  menuOpen={isMenuOpen}
                  setMenuOpen={setMenuOpen}
                />
                <MenuItem>
                  <NavLink
                    style={{
                      color: isMenuOpen
                        ? "#fff"
                        : isBaseUrl && !scrolled
                        ? "#091C00"
                        : "#091C00",
                      fontWeight: 500,
                    }}
                    to={"/marketplace"}
                  >
                    AI Ranking
                  </NavLink>
                </MenuItem>
                <MenuItem>
                {/*
                  {token ? (
                    <div
                      style={{ position: "relative", width: "115px" }}
                      ref={menuRef}
                    >
                      <Button
                        onClick={
                          !location.pathname.includes("dashboard")
                            ? handleNavigateToDashboard
                            : toggleWalletMenu
                        }
                      >
                        My Wallet
                      </Button>
                      <MenuComponent
                        items={[{ title: "Logout", icon: <LogoutIcon /> }]}
                        onSelect={handleMenuSelect}
                        isVisible={isMenuVisible}
                      />
                    </div>
                  ) : (
                    <ConnectBtn onClick={handleToggleModal}>
                      Connect
                      <span>
                        <ConnectWallet />
                      </span>
                    </ConnectBtn>
                  )}
                    */}
                </MenuItem>
              </div>
            )}
            <WalletsModal
              open={walletModalOpen}
              handleClose={handleToggleModal}
            />
          </div>
        </HeaderContainer>
      </HeaderMainWrapper>
    </>
  );
});
